import { render, staticRenderFns } from "./update.vue?vue&type=template&id=b2021186&scoped=true"
import script from "./update.vue?vue&type=script&lang=js"
export * from "./update.vue?vue&type=script&lang=js"
import style0 from "./update.vue?vue&type=style&index=0&id=b2021186&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2021186",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2021186')) {
      api.createRecord('b2021186', component.options)
    } else {
      api.reload('b2021186', component.options)
    }
    module.hot.accept("./update.vue?vue&type=template&id=b2021186&scoped=true", function () {
      api.rerender('b2021186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exercise/list/update.vue"
export default component.exports